__turbopack_context__.v({
  "confirmation": "jQPU0q_confirmation",
  "content": "jQPU0q_content",
  "footer": "jQPU0q_footer",
  "itsme": "jQPU0q_itsme",
  "registration": "jQPU0q_registration",
  "terms-checkbox": "jQPU0q_terms-checkbox",
  "wrapper": "jQPU0q_wrapper",
});
